import React from 'react'
import { Link } from 'react-router'
import RaisedButton from 'material-ui/RaisedButton'
import { Tabs, Tab } from 'material-ui/Tabs'

const OutreachHeader = ({ filter, headerCard, onChange }) => {
  return (
     <div className="outreach-header">
       {headerCard}
       <div className="outreach-bar">
         <div className="outreach-filter">
           <div className="filter-header">
             <p>FILTER EVENTS</p>
           </div>
           <div className="filter-content">
           <Tabs
            inkBarStyle={{ backgroundColor: '#aa82ff', marginTop: '.25em'}}
            style={{ width: '100%' }}
            tabItemContainerStyle={{ backgroundColor: 'white' }}
            value={filter}
           >
            <Tab
              className={filter === 'all' ? 'active' : 'inactive'}
             label={<p>All Events</p>}
             onActive={()=>{onChange('all')}}
             style={{color: 'black', fontFamily: 'Menlo', textAlign: 'left'}}
             value={'all'}>
            </Tab>
            <Tab
              className={filter === 'Made by Mind Makers' ? 'active' : 'inactive'}
              label={<p>Made by Mind Makers</p>}
              onActive={()=>{onChange('Made by Mind Makers')}}
              style={{color: 'black', fontFamily: 'Menlo', textAlign: 'left'}}
              value={'Made by Mind Makers'}>
            </Tab>
            <Tab
              className={filter === 'Ally Events' ? 'active' : 'inactive'}
              label={<p>Ally Events</p>}
              onActive={()=>{onChange('Ally Events')}}
              style={{color: 'black', fontFamily: 'Menlo', textAlign: 'left'}}
              value={'Ally Events'}>
            </Tab>
           </Tabs>
           </div>
         </div>
         <div className="outreach-button">
           <Link to="/get-involved/hosting">
             <RaisedButton
               className="view-button"
               label="Host A Workshop"
               primary={true}
               style={{width: '200px', marginTop: '10px', marginBottom: '5px'}}
             />
           </Link>
         </div>
       </div>
     </div>
 )
}

export default OutreachHeader



// WEBPACK FOOTER //
// ./src/components/Outreach/OutreachHeader.js